import React, { useEffect, useState } from "react";
import "../Services/Services.css";
import CharIcon from "../../Assets/img/word.png";
import UploadIcon from "../../Assets/img/upload.png";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import API from "../Service/Baseservice";
import Loading from "../../Loading/loading";
import WhyChooseUsPreview from "./WhyChooseUsPreview";
const defaultServiceIdMap = {
  1: 3,  // English default service_id
  2: 8,  // French default service_id
};

const defaultListOfServiceIdMap = {
  1: "",
  2: "",
};
const WhyChooseUsEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams(); // service_id
  const query = new URLSearchParams(useLocation().search);
  const lang = Number(query.get("lang")) || 1;
  const list = Number(query.get("list")) || "";
  const [selectedService, setSelectedService] = useState(list);
  const [form, setForm] = useState({
    whychooseus_id: "",
    language_id: lang,
    service_id: id,
    listofservice_id: selectedService || "",
    heading: "",
    description: "",
    image: "",
    createdBy: 1,
    updatedBy: 1,
  });
  const [popup, setPopup] = useState({
    show: false,
    title: "",
    message: "",
    type: "",
  });
  const [cards, setCards] = useState([]);
  const [imagePreview, setImagePreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [servicesList, setServicesList] = useState([]);
  const [showAddPopup, setShowEditPopup] = useState(false);
  const [editForm, setEditForm] = useState({ label_name: "", placeholder: "" });
  const [mainData, setMainData] = useState({ label_name: "", placeholder: "" });
  const [showPreviewWhyChooseUs, setShowPreviewWhyChooseUs] = useState(false);
  const [previewData, setPreviewData] = useState(null);
  const newCards = cards.filter(c => !c.wcu_id);
  const existingCards = cards.filter(c => c.wcu_id);
  const toBase64 = (file, callback) => {
    const reader = new FileReader();
    reader.onload = () => callback(reader.result);
    reader.readAsDataURL(file);
  };

  const getPlainTextLength = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return (div.textContent || div.innerText || "").length;
  };

  const fetchServices = () => {
    API.post("listofservice_list/condition", { language_id: lang })
      .then((res) => {
      const active = (res?.data?.data?.data || [])
  .filter((x) => x.active === 1 || x.active === "1")
  .sort((a, b) => Number(a.order_by) - Number(b.order_by));
        setServicesList(active);
      })
      .catch((err) => console.error("Service load error:", err));
  };


  useEffect(() => {
    fetchServices();
  }, [lang]);

  useEffect(() => {
    if (!id || !lang) return;

    const listIdToSend = selectedService || "";
    API.post("whychooseusListView/condition", {
      language_id: lang,
      service_id: id,
      listofservice_id: listIdToSend,
    })
      .then(res => {
        const list = res?.data?.data?.data || [];

        if (!list.length) {
          setForm({ whychooseus_id: "", listofservice_id: "", service_id: id, title: "", heading: "", description: "", image: "", "createdBy": 1, "updatedBy": 1 });
          setCards([]);
          setImagePreview(null);
          return;
        }

        const first = selectedService ? list[0] : list.find(item => item.listofservice_id === "") || list[0];

        setForm({
          ...form,
          whychooseus_id: first.whychooseus_id,
          listofservice_id: first.listofservice_id,
          service_id: first.service_id,
          title: first.title,
          heading: first.heading,
          description: first.description,
          image: first.image,
          createdBy: 1,
          updatedBy: 1,
        });

        setCards(first.cards || []);
        setImagePreview(first.image || null);

      })
      .catch(err => console.error(err));
  }, [id, lang, selectedService]);





  const updateField = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };


  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setLoading(true);

    toBase64(file, (base64) => {
      const payload = {
        name: file.name,
        image: [
          {
            name: file.name,
            type: file.type,
            size: file.size + " bytes",
            base64: base64,
          },
        ],
      };

      API.post("imageUpload/add", payload)
        .then((res) => {
          if (res.data.success) {
            const finalUrl = res.data.url;
            updateField("image", finalUrl);
            setImagePreview(finalUrl);
          } else {
            alert("Image upload failed");
          }
        })
        .catch((err) =>
          console.error("Image Upload Error: ", err)
        )
        .finally(() => setLoading(false));
    });
  };

  const handleSubmit = () => {
    if (!form.title.trim()) {
      return setPopup({
        show: true,
        title: "Required",
        message: "Title is required!",
        type: "info",
      });
    }

    if (!form.heading.trim()) {
      return setPopup({
        show: true,
        title: "Required",
        message: "Heading is required!",
        type: "info",
      });
    }

    if (!form.description.trim()) {
      return setPopup({
        show: true,
        title: "Required",
        message: "Description is required!",
        type: "info",
      });
    }

    if (!form.image) {
      return setPopup({
        show: true,
        title: "Required",
        message: "Please upload an image!",
        type: "info",
      });
    }

    for (let c of cards) {
      if (!c.label_name.trim()) {
        return setPopup({
          show: true,
          title: "Required",
          message: "All card labels are required!",
          type: "info",
        });
      }
      if (!c.percentage && c.percentage !== 0) {
        return setPopup({
          show: true,
          title: "Required",
          message: "All card percentages are required!",
          type: "info",
        });
      }
    }

    const newCards = cards.filter(c => !c.wcu_id);
    const existingCards = cards.filter(c => c.wcu_id);

    setLoading(true);
    const payload = {
      ...form,
      service_id: Number(id),
      language_id: lang,
      listofservice_id: selectedService || "",
      cards: form.whychooseus_id ? existingCards : cards   // ⭐ KEY FIX
    };

    API.post("whychooseus_edit/update", payload)
      .then((res) => {
        const finalId = form.whychooseus_id || res.data?.whychooseus_id;
        if (!form.whychooseus_id) {
          setPopup({
            show: true,
            title: "Success",
            message: "Created successfully!",
            type: "success",
          });

          setTimeout(() => navigate("/services"), 1500);
          return;
        }

        if (newCards.length === 0) {
          setPopup({
            show: true,
            title: "Success",
            message: "Updated successfully!",
            type: "success",
          });

          setTimeout(() => navigate("/services"), 1500);
          return;
        }

        const requests = newCards.map(card =>
          API.post("add_wcu_label/add", {
            language_id: lang,
            whychooseus_id: finalId,
            label_name: card.label_name,
            percentage: card.percentage,
            status: "active",
            createdBy: 1,
            updatedBy: 1,
          })
        );

        Promise.all(requests)
          .then(() => {
            setPopup({
              show: true,
              title: "Success",
              message: "Updated successfully!",
              type: "success",
            });

            setTimeout(() => navigate("/services"), 1500);
          })
          .catch(() => {
            setPopup({
              show: true,
              title: "Error",
              message: "Labels partially failed!",
              type: "error",
            });
          });
      })
      .catch(() => {
        setPopup({
          show: true,
          title: "Error",
          message: "Error saving data!",
          type: "error",
        });
      })
      .finally(() => setLoading(false));
  };

  const handleLanguageChange = (newLang) => {
    const defaultServiceId = defaultServiceIdMap[newLang];
    const defaultListId = defaultListOfServiceIdMap[newLang];

    setSelectedService(defaultListId);

    navigate(
      `/whychooseusedit/${defaultServiceId}?lang=${newLang}&list=${defaultListId}`,
      { replace: true }
    );
  };
  const handleAddLocalCard = () => {
    if (!editForm.label_name.trim()) return;

    setCards(prev => [
      ...prev,
      {
        label_name: editForm.label_name,
        percentage: Number(editForm.percentage),
      }
    ]);

    setShowEditPopup(false);
  };

  const handleToggleStatus = (wcuId, currentStatus) => {
    const newStatus = currentStatus === "active" ? "inactive" : "active";

    setLoading(true);

    API.post("wculabel_status/update", {
      wcu_id: wcuId,
      status: newStatus,
    })
      .then(() => {
        return API.post("whychooseusListView/condition", {
          language_id: lang,
          service_id: id,
          listofservice_id: selectedService || "",
        });
      })
      .then((res) => {
        const list = res?.data?.data?.data || [];

        const cardsData = list[0]?.cards || [];

        setCards(cardsData);
      })
      .catch((err) => console.error("Status update failed:", err))
      .finally(() => setLoading(false));
  };

  const handlePreview = () => {
    if (!form.heading.trim()) {
      return setPopup({
        show: true,
        title: "Warning",
        message: "Heading is required for preview.",
        type: "info",
      });
    }

    if (!form.title.trim()) {
      return setPopup({
        show: true,
        title: "Warning",
        message: "Title is required for preview.",
        type: "info",
      });
    }

    if (!imagePreview) {
      return setPopup({
        show: true,
        title: "Warning",
        message: "Please upload an image before previewing.",
        type: "info",
      });
    }

    if (cards.length < 1) {
      return setPopup({
        show: true,
        title: "Warning",
        message: "Please add at least one label before preview.",
        type: "info",
      });
    }

    for (let card of cards) {
      if (!card.label_name.trim()) {
        return setPopup({
          show: true,
          title: "Warning",
          message: "Each card must have a label name.",
          type: "info",
        });
      }

      if (card.percentage === "" || card.percentage === null || card.percentage === undefined) {
        return setPopup({
          show: true,
          title: "Warning",
          message: "Each card must have a valid percentage.",
          type: "info",
        });
      }
    }

    const previewPayload = {
      ...form,
      image: imagePreview,
      cards: cards,
      whychooseus_id: "preview_mode"
    };

    setPreviewData(previewPayload);
    setShowPreviewWhyChooseUs(true);
  };
  const MAX_CHARS = 4000;
  const [lastValidDescription, setLastValidDescription] = useState(form.description);


  return (
    <div className="newss-containeradd">
      <div className="service-header-bar">
        <h2 className="services-title1">Edit Why Choose Us</h2>

        <div className="button-group">
          <div className="filter-block">
            <label>Language</label>
            <div className="input-container">
              <select
                className="input-field"
                value={lang}
                onChange={(e) => handleLanguageChange(Number(e.target.value))}
              >
                <option value={1}>English</option>
                <option value={2}>Français</option>
              </select>
            </div>
          </div>

          <div className="filter-block">
            <label>Service Name</label>
            <div className="input-container">
              <select
                className="input-field"
                value={selectedService}
                onChange={(e) => {
                  const value = Number(e.target.value);
                  setSelectedService(value);
                  updateField("listofservice_id", value);
                  API.post("whychooseusListView/condition", {
                    language_id: lang,
                    service_id: id,
                    listofservice_id: value,
                  }).then(res => {
                    const responseData = res?.data?.data || {};
                    const first = responseData.whychooseus?.[0];
                    const cardsData = responseData.cards || [];
                    if (!first) {
                      setForm({
                        whychooseus_id: "",
                        language_id: lang,
                        service_id: id,
                        listofservice_id: "",
                        title: "",
                        heading: "",
                        description: "",
                        image: "",
                        createdBy: 1,
                        updatedBy: 1,
                      });
                      setCards([]);
                      setImagePreview(null);
                      return;
                    }
                  });
                }}
              >

                {servicesList.map((cat) => (
                  <option key={cat.listofservice_id} value={cat.listofservice_id}>
                    {cat.heading}
                  </option>
                ))}
              </select>

            </div>
          </div>
          <button onClick={handlePreview} className="language-save-btn">
            Preview
          </button>
          <button
            className="language-save-btn"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? "Save" : "Save"}
          </button>

          <button
            onClick={() => navigate("/services")}
            className="language-cancel-btn"
          >
            Back
          </button>
        </div>
      </div>
      {loading ? (
        <Loading />
      ) : (
        <>
          <div className="why-choose-us">
            <div className="service-container">
              <div className="wcu-left-form">
                <div className="wcu-form-group">
                  <label>
                    Title <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Enter title"
                    value={form.title}
                    onChange={(e) =>
                      updateField("title", e.target.value)
                    }
                  />
                </div>
                <div className="wcu-form-group">
                  <label>
                    Heading <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Enter heading"
                    value={form.heading}
                    onChange={(e) =>
                      updateField("heading", e.target.value)
                    }
                  />
                </div>

                <div className="news-form-group editor-small">
                  <label className="news-description-label">
                    <span>
                      Description <span className="required">*</span>
                    </span>
                    <div className="char-wrapper">
                      <img src={CharIcon} alt="count" />
                      <span className="char-count">
                        {getPlainTextLength(form.description)}/4000
                      </span>
                    </div>
                  </label>

                  <CKEditor
                    editor={ClassicEditor}
                    data={form.description}

                    onChange={(event, editor) => {
                      const html = editor.getData();

                      // Convert HTML → plain text
                      const div = document.createElement("div");
                      div.innerHTML = html;
                      const text = div.textContent || "";

                      if (text.length <= MAX_CHARS) {
                        // ✅ Save valid content
                        setLastValidDescription(html);
                        setForm(prev => ({
                          ...prev,
                          description: html
                        }));
                      } else {
                        editor.setData(lastValidDescription);
                      }
                    }}

                    config={{
                      toolbar: [
                        "undo", "redo", "|",
                        "heading", "|",
                        "bold", "italic", "underline", "|",
                        "bulletedList", "numberedList",
                      ],
                    }}
                  />



                </div>

              </div>

              {/* RIGHT SIDE */}
              <div className="whychooseus-right-section">
                <div className="upload-section">
                  <label>
                    Upload Image <span style={{ color: "red" }}>*</span>
                  </label>

                  <div className="whychooseus-upload-box">
                    {imagePreview ? (
                      <img
                        src={imagePreview}
                        alt="preview"
                        className="preview-img"
                      />
                    ) : (
                      <>
                        <img
                          src={UploadIcon}
                          alt=""
                          className="upload-icon"
                        />
                        <p>Click to upload</p>
                      </>
                    )}

                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleImageChange}
                    />
                  </div>
                </div>
              </div>

            </div>
            <div className="why-choose-us-container">
              <div className="category-header1">
                <h2 className="category-title1">List Label</h2>
                <div className="header-buttons">
                  <button
                    className="btn saves-btn"
                    onClick={() => {
                      setEditForm({
                        label_name: mainData.label_name,
                        placeholder: mainData.placeholder,
                      });
                      setShowEditPopup(true);
                    }}
                  >
                    Add Label
                  </button>
                </div>
              </div>
              {/* Cards */}
              <div className="social-grid">
                {cards.map((card, index) => (
                  <div className="social-item" key={index}>
                    <div className="wcu-status-container">
                      <label className="wcu-switch">
                        <input
                          type="checkbox"
                          checked={card.status === "active"}
                          onChange={() =>
                            handleToggleStatus(card.wcu_id, card.status)
                          }
                        />
                        <span className="wcu-slider round">
                          <span className="wcu-switch-label">
                            {card.status === "active" ? "ON" : "OFF"}
                          </span>
                        </span>
                      </label>
                    </div>

                    <div className="social-inputs">
                      <div className="input-group1">
                        <label>Label</label>
                        <input
                          type="text"
                          value={card.label_name}
                          onChange={(e) => {
                            const newCards = [...cards];
                            newCards[index].label_name = e.target.value;
                            setCards(newCards);
                          }}
                        />
                      </div>

                      <div className="input-group1">
                        <label>Percentage</label>
                        <input
                          type="number"
                          value={card.percentage}
                          onChange={(e) => {
                            const newCards = [...cards];
                            newCards[index].percentage = Number(e.target.value);
                            setCards(newCards);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>

            </div>
          </div>
          {showAddPopup && (
            <div className="blogtag-popup-overlay">
              <div className="blogtag-popup-box edit-mode">
                <h3>Add Label</h3>

                <div className="blogtag-admin-form-group">
                  <label>Label</label>
                  <input
                    type="text"
                    value={editForm.label_name}
                    onChange={(e) =>
                      setEditForm({ ...editForm, label_name: e.target.value })
                    }
                  />
                </div>

                <div className="blogtag-admin-form-group">
                  <label>Percentage</label>
                  <input
                    type="text"
                    value={editForm.percentage}
                    onChange={(e) => {
                      const cleaned = e.target.value.replace(/\D/g, ""); // remove NON-numbers
                      setEditForm({ ...editForm, percentage: cleaned });
                    }}
                  />

                </div>

                <div className="blogtag-popup-buttons">
                  <button
                    className="cancel-btn "
                    onClick={() => setShowEditPopup(false)}
                  >
                    Back
                  </button>

                  <button className="btn saves-btn" onClick={handleAddLocalCard}>
                    Save
                  </button>
                </div>
              </div>
            </div>
          )}
        </>
      )}
      {showPreviewWhyChooseUs && (
        <WhyChooseUsPreview
          previewService={previewData}
          setShowPreviewWhyChooseUs={setShowPreviewWhyChooseUs}
        />
      )}
      {popup.show && (
        <div className="popup-overlay">
          <div className={`popup-box popup-${popup.type}`}>
            <h3>{popup.title}</h3>
            <p>{popup.message}</p>
            <button className="btn ok-btn" onClick={() => setPopup({ ...popup, show: false })}>
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default WhyChooseUsEdit;